export class FcdSegment {
  fcdOriginalSegmentID: number;
  fcdInternalSegmentID: number;
  fcdFingerprintSegmentID: number;
  fcdLength: number;
  fcdBeginFraction: number;
  fcdEndFraction: number;
  fcdTrajectoryCoverage: number;
  fcdTrajectorySpecificity: number;
  fcdSubtrajectorySpecificity: number;
  fcdSegmentFreeFlowSpeed: number;
}



// WEBPACK FOOTER //
// ./src/app/models/fcd/fcdsegment.model.ts